import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { smsLogoutCleaning, startLoadingSmsLogs, startLoadingSmsStats } from '../../actions/sms';
import { setMenuLateral } from '../../actions/ui';
import { ArrowDownSmallIcon } from '../../assets/svg/iconos';
import { SmsLogRowItem } from './components/SmsLogRowItem';
import { SmsStatsCards } from './components/SmsStatsCards';

export const SmsLogs = () => {
    const dispatch = useDispatch();
    const { logs, total, stats } = useSelector(state => state.sms);
    const { colores } = useSelector(state => state.ui);

    const [pagNumber, setPagNumber] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const tableScrollableRef = useRef(null);
    
    const LIMITE_LOGS = 20;

    useEffect(() => {
        dispatch(setMenuLateral('sms'));
        dispatch(startLoadingSmsLogs(1, LIMITE_LOGS));
        dispatch(startLoadingSmsStats());
        
        return () => {
            dispatch(smsLogoutCleaning());
        }
    }, [dispatch]);

    useEffect(() => {
        if (logs.length > 0) {
            setIsLoading(false);
        }
    }, [logs]);

    const paginacion = (valor) => {
        let newPage = pagNumber;
        
        if (valor === -1000) {
            newPage = 1;
        } else if (valor === 1) {
            newPage = pagNumber + 1;
        } else if (valor === 1000000000) {
            newPage = Math.ceil(total / LIMITE_LOGS);
        } else {
            if (pagNumber <= 1) return;
            newPage = pagNumber - 1;
        }
        
        setPagNumber(newPage);
        setIsLoading(true);
        dispatch(startLoadingSmsLogs(newPage, LIMITE_LOGS));
        
        if (tableScrollableRef.current) {
            tableScrollableRef.current.scrollTop = 0;
        }
    };

    return (
        <div 
            className='sms-logs empresas'
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >
            <div className="preheader">
                <div className="title">
                    <h1 style={{color: colores.colorPrincipal}}>Logs SMS</h1>
                </div>
                <div className="botonera">
                    {total > 0 && (
                        <div className="total-count" style={{ color: colores.colorPrincipal }}>
                            Total: {total} envíos
                        </div>
                    )}
                </div>
            </div>
            
            <SmsStatsCards stats={stats} />
            
            <div className="table-empresas">
                <div className='table-scrollable' ref={tableScrollableRef}>
                    <div className='table-row headers-row'>
                        <div className='column fecha'>
                            <p>Fecha</p>
                            <span><ArrowDownSmallIcon /></span>
                        </div>
                        <div className='column empresa'>
                            <p>Empresa</p>
                        </div>
                        <div className='column telefono'>
                            <p>Teléfono</p>
                        </div>
                        <div className='column tipo'>
                            <p>Tipo</p>
                        </div>
                        <div className='column estado'>
                            <p>Estado</p>
                        </div>
                        <div className='column entrega'>
                            <p>Entrega</p>
                        </div>
                        <div className='column mensaje'>
                            <p>Mensaje</p>
                        </div>
                    </div>
                    
                    {!isLoading && logs.map(log => (
                        <SmsLogRowItem
                            key={log._id}
                            log={log}
                        />
                    ))}
                    
                    {logs.length === 0 && !isLoading && (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                            <h3>No hay logs de SMS disponibles</h3>
                        </div>
                    )}
                </div>
            </div>
            
            {
                total > LIMITE_LOGS && (
                <div className='paginacion'>
                    <div 
                        className='pag-btn'
                        style={{ 
                            backgroundColor: colores.color6, 
                            color: colores.colorPrincipal,
                            opacity: pagNumber > 1 ? 1 : 0
                        }}
                        onClick={() => paginacion(-1000)}
                    >{'<<'}</div>
                    <div 
                        className='pag-btn'
                        style={{ 
                            backgroundColor: colores.color6,
                            color: colores.colorPrincipal,
                            opacity: pagNumber > 1 ? 1 : 0
                        }}
                        onClick={() => paginacion(-1)}
                    >{'<'}</div>
                    <div className='pag-number'>
                        Página: {pagNumber}
                    </div>
                    <div 
                        className='pag-btn'
                        onClick={() => paginacion(1)}
                        style={{ 
                            backgroundColor: colores.color6,
                            color: colores.colorPrincipal,
                            opacity: pagNumber < Math.ceil(total / LIMITE_LOGS) ? 1 : 0
                        }}
                    >{'>'}</div>
                    <div 
                        className='pag-btn'
                        onClick={() => paginacion(1000000000)}
                        style={{ 
                            backgroundColor: colores.color6,
                            color: colores.colorPrincipal,
                            opacity: pagNumber < Math.ceil(total / LIMITE_LOGS) ? 1 : 0
                        }}
                    >{'>>'}</div>
                </div>
                )
            }
            
            {isLoading && (
                <div className='loading-clientes'>
                    <div className='bg-loading'></div>   
                    <p style={{ color: colores.colorPrincipal }}>Cargando...</p>
                </div>
            )}
        </div>
    );
};